export const PRICING_NODE_LABELS = {
    rates: 'Rate card',
    overview: 'Overview',
    indirects: 'Indirects',
    clins: 'CLINs',
    tiers: 'Shared tiers',
    versions: 'Versions',
    'price-volume': 'Price volume'
};
export function pricingHref(projectId, scenarioId, node = 'rates', query = {}) {
    const base = `/proposal/${encodeURIComponent(projectId)}/v2/sources/pricing`;
    const path = scenarioId ? `${base}/${encodeURIComponent(scenarioId)}/${node.split('/').map(encodeURIComponent).join('/')}` : base;
    const params = new URLSearchParams();
    if (query.period) params.set('period', query.period);
    if (query.row) params.set('row', query.row);
    return path + (params.size ? `?${params}` : '');
}
export function parsePricingParams(params, search) {
    const node = params.clinNumber ? 'clins' : params.tierId ? 'tiers' : params.node ?? 'rates';
    return {
        node: PRICING_NODE_LABELS[node] ? node : 'rates',
        period: search.get('period') || 'base',
        row: search.get('row') || ''
    };
}
